/* tslint:disable */
/* eslint-disable */

/**
 * 65 = Installation
 * 
 * 66 = SixMonthly
 * 
 * 67 = TwelveMonthly
 * 
 * 68 = WrittenScheme
 * 
 * 69 = ExceptionalCircumstances
 */
export enum ExaminationReason {
  Installation = 65,
  SixMonthly = 66,
  TwelveMonthly = 67,
  WrittenScheme = 68,
  ExceptionalCircumstances = 69
}
